import { watchEffect, type Ref, type ComputedRef } from 'vue';

/**
 * Sets the document title reactively based on a provided source.
 * @param titleSource A Ref or ComputedRef containing the desired document title.
 * @param baseTitle Optional base title to append (e.g., ' | MyAppName').
 */
export function useDocumentTitle(
  titleSource: Ref<string | null | undefined> | ComputedRef<string | null | undefined>,
  baseTitle: string = 'EdReports.org'
) {
  watchEffect(() => {
    const titleValue = titleSource.value;
    if (titleValue) {
      document.title = `${baseTitle} | ${titleValue}`;
    } else {
      document.title = baseTitle;
    }
  });
} 